<template>
    <o-modal @showModalDuration="showModalDuration" @close="closeModalDuration">
        <template v-slot:header>
            {{ item.title }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="custom-alert modern-alert error-alert mb-4">
                        <div class="alert-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-content">
                            <h6 class="alert-title">Please correct the following error(s):</h6>
                            <ul class="alert-list">
                                <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <o-form-group title="Expiration Tier Duration" name="state" class="form-group-modern text-start">
                    <span class="text-danger"> *</span>
                    <br>
                    <div class="expiration">
                        <div class="month me-3">
                            <label for="" class="mb-1">Month <span class="text-danger"> *</span></label>
                            <o-input-text name="expiration_month" v-model="item.month" type="number" :required="true" class="modern-input" placeholder="0" />
                        </div>
                        <div class="day">
                            <label for="" class="mb-1">Day <span class="text-danger"> *</span></label>
                            <o-input-text name="expiration_day" v-model="item.day" type="number" min="0" max="30" :required="true" class="modern-input" placeholder="0" />
                        </div>
                    </div>
                </o-form-group>
                <div class="d-flex justify-content-between mt-4">
                    <button @click.prevent="closeModalDuration" class="btn btn-light text-white px-4 fw-medium" type="button" style="background-color: #B9B9B9; border: none;">Cancel</button>
                    <o-button @click="saveDetailDuration" :variant="'primary'" type="submit" class="px-4 text-white">Save</o-button>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OInputText, OButton } from '@/components/OmnihControl';
import { mapState } from 'vuex';

export default {
    name: 'AddDetailDuration',
    components: {
        OModal,
        OForm,
        OFormGroup,
        OInputText,
        OButton,
    },
    props: [
        'editedItemDuration',
        'validationdetail',
    ],
    data() {
        return {
            item: {
                expiration: 0,
                title: 'New Member Tier Duration'
            },
            validationDetail: this.validationdetail,
            isModalVisibleDuration: false,
            errors: [],
        }
    },
    mounted() {
        if (Object.keys(this.editedItemDuration).length !== 0) {
            this.item = { ...this.editedItemDuration };
            const formattedExpiration = this.expiration(this.item.expiration);
            this.item.month = formattedExpiration.month;
            this.item.day = formattedExpiration.day;
            this.item.title = 'Edit Member Tier Duration';
        }
    },
    methods: {
        showModalDuration() {
            this.isModalVisibleDuration = true;
        },
        closeModalDuration(e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            this.$emit('parentCloseModal');
        },
        saveDetailDuration() {
            this.errors = [];

            if (this.item.month === null || this.item.month === "") {
                this.errors.push('Month is required.');
            }

            if (this.item.day === null || this.item.day === "" || this.item.day == undefined) {
                this.errors.push('Day is required.');
            }

            if (this.errors.length === 0) {
                const expirationSeconds = this.item.month * 2592000 + this.item.day * 86400;
                this.item.expiration = expirationSeconds;

                this.$emit('parentAddItem', this.item);
                this.isModalVisibleDuration = false;
            }
        },
        expiration(value) {
            const expiration_month = Math.floor(Number(value) / 2592000);
            const expiration_day = Math.floor((Number(value) - (expiration_month * 2592000)) / 86400);

            return {
                month: expiration_month,
                day: expiration_day
                };
            },
        },
    computed: {
        ...mapState({
        
        }),
    }
}
</script>

<style>
.spinner {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 100%;
}
.spinner-position {
    display: block;
    position: fixed;
    z-index: 1031;
    top: 50%;
    right: 50%;
    margin-top: 5px;
    margin-left: 80px;
}

/* Modern Form Styles */
.form-group-modern {
    font-weight: 500;
    color: #475569;
}

.modern-input {
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
    width: 100%;
}

.modern-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    outline: none;
}

.btn-save-modern {
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 600;
    transition: transform 0.1s, box-shadow 0.1s;
}

.btn-save-modern:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 8px -1px rgba(59, 130, 246, 0.5);
}

.btn-action-secondary {
    background-color: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.2s;
}

.btn-action-secondary:hover {
    background-color: #e2e8f0;
    color: #0f172a;
}

/* Modern Alert Styles */
.modern-alert {
  display: flex;
  align-items: flex-start;
  background-color: #fef2f2;
  border-left: 5px solid #ef4444;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.3s ease-out;
}

.modern-alert .alert-icon {
  flex-shrink: 0;
  margin-right: 14px;
  font-size: 20px;
  color: #ef4444;
}

.modern-alert .alert-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #991b1b;
}

.alert-list {
  margin: 0;
  padding-left: 16px;
  font-size: 13px;
  color: #b91c1c;
}

.expiration {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

.expiration .month,
.expiration .day {
  flex: 1;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
